import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Theme Toggle
;(function() {
  const STORAGE_KEY = 'theme'

  function getSystemTheme() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }

  function applyTheme(theme) {
    const effectiveTheme = theme === 'system' ? getSystemTheme() : theme
    document.documentElement.classList.toggle('dark', effectiveTheme === 'dark')
  }

  function updateToggleUI(theme) {
    document.querySelectorAll('.theme-toggle button').forEach(btn => {
      const isActive = btn.dataset.theme === theme
      btn.classList.toggle('active', isActive)
      btn.setAttribute('aria-checked', isActive)
    })
  }

  function setTheme(theme) {
    localStorage.setItem(STORAGE_KEY, theme)
    applyTheme(theme)
    updateToggleUI(theme)
  }

  function initTheme() {
    const stored = localStorage.getItem(STORAGE_KEY) || 'system'
    applyTheme(stored)
    updateToggleUI(stored)

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      if (localStorage.getItem(STORAGE_KEY) === 'system') {
        applyTheme('system')
      }
    })
  }

  const stored = localStorage.getItem(STORAGE_KEY) || 'system'
  applyTheme(stored)

  document.addEventListener('DOMContentLoaded', () => {
    initTheme()

    document.querySelectorAll('.theme-toggle button').forEach(btn => {
      btn.addEventListener('click', () => setTheme(btn.dataset.theme))
    })
  })
})()
